import React from 'react';
import styled from 'styled-components';
import {
  TableWithButtonRow,
  TableWrapper,
  Table,
  Tr,
  TrHead,
  Th,
  TBody,
  Td,
  LoadingBlueLarge,
} from 'merchant-portal-components';
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';
import NoDataMessage from '../../../../../components/NoDataMessage/NoDataMessage';
import { Box } from '@material-ui/core';

const Wrapper = styled.div`
  width: 100%;
`;

const styles = {
  switchBase: {
    transition: 'none',
  },
  switchBaseDefault: {
    transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  },
};

const CategoryList = ({
  categories,
  toggleCategory,
  initiateEditCategory,
  requestParams,
  isRequestingGetCategories,
  isSearching,
  selectedFilter,
  searchString,
}) => {
  const renderHeaders = () => {
    return (
      <TrHead>
        <Th
          align='left'
          style={{ paddingLeft: '37px' }}
          value='name'
          sortingOption={requestParams.sorting_option}
        >
          Name
        </Th>
        <Th
          style={{ minWidth: '150px' }}
          align='left'
          value='subLength'
          sortingOption={requestParams.sorting_option}
        >
          SubCategories
        </Th>
        <Th
          align='right'
          style={{ paddingRight: '45px' }}
          value='is_active'
          sortingOption={requestParams.sorting_option}
        >
          Active
        </Th>
      </TrHead>
    );
  };

  const renderSubCategoryString = (category) => {
    if (category.sub_categories.length === 0) return 'No Subcategories';
    if (category.sub_categories.length === 1) return '1 Subcategory';
    else {
      return category.sub_categories.length + ' ' + 'Subcategories';
    }
  };

  const renderRows = () => {
    return categories.map((category, index) => (
      <Tr
        onClick={() => initiateEditCategory(category)}
        key={index}
        style={{ cursor: 'pointer', height: '78px' }}
      >
        <Td padding={'0px 0px 0px 37px'}>{category.name}</Td>
        <Td>{renderSubCategoryString(category)}</Td>
        <Td padding={'0px 37px 0px 0px'} style={{ textAlign: 'right' }}>
          <Switch
            checked={category.is_active}
            onClick={(e) => e.stopPropagation()}
            onChange={() => toggleCategory(category, !category.is_active)}
            value='checkedB'
            color='primary'
            inputProps={{ 'aria-label': 'primary checkbox' }}
          />
        </Td>
      </Tr>
    ));
  };
  return (
    <Wrapper>
      <TableWithButtonRow marginLeft='37px' marginRight='37px'>
        <TableWrapper noShadow>
          {isRequestingGetCategories || isSearching ? (
            <Box sx={{ borderTop: '1px solid lightgray' }}>
              <LoadingBlueLarge />
            </Box>
          ) : categories.length > 0 ? (
            <Table noBorder>
              <thead>{renderHeaders()}</thead>
              <TBody striped>{renderRows()}</TBody>
            </Table>
          ) : (
            <Box sx={{ borderTop: '1px solid lightgray' }}>
              <NoDataMessage
                selectedFilter={selectedFilter}
                searchString={searchString}
                type='categories'
              />
            </Box>
          )}
        </TableWrapper>
      </TableWithButtonRow>
    </Wrapper>
  );
};

export default withStyles(styles)(CategoryList);
